import type { ColTypeDef } from 'ag-grid-community';
import { ProgressBarCellRenderer } from 'components/shared/Blotter/Grid/CellRenderers/ProgressBarCellRenderer';
import { agSetColumnFilter } from 'components/shared/Blotter/Grid/Hooks/utils';
import { useMemo } from 'react';

export function useRelativeTimeColumnType<T>(handleValuesUpdate: boolean = false): ColTypeDef<T> {
  return useMemo(
    () => agSetColumnFilter({ cellRenderer: ProgressBarCellRenderer }, handleValuesUpdate),
    [handleValuesUpdate],
  );
}
